import $ from 'jquery';

let linkOffice = $('.two-columns-block__link .office')
linkOffice.click(function(e) {
  let href = e.target.getAttribute('href');
  let text = $(this).text();
  if(href) {
      if (text === 'Отримати кар’єрну консультацію') {
        location.href = href + "?q=office_career";
        e.preventDefault();
      } else {
        location.href = href + "?q=office_psychologist";
        e.preventDefault();
      }
  }
});
